import script from "./AdDream.vue?vue&type=script&setup=true&lang=js"
export * from "./AdDream.vue?vue&type=script&setup=true&lang=js"

import "./AdDream.vue?vue&type=style&index=0&id=1eb5d451&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eb5d451"]])

export default __exports__